<template>
    <div class="pt-5 pb-3 center"
    :style="{ backgroundImage: 'url(' + background + ')'}">
         <ul class="admin-menu center">
            <li 
            v-for="(city, index) in cities" :key="city.id"
            @click="activate(index); getInfo(city); changeDeptos(city), setHistoryOptionCsv(false)" 
            :class="{ active : elementIndex == index}"            
            >{{city}}</li>
        </ul>
    </div>
</template>

<script>
import img from '../assets/fondoazul2.png';
import {mapActions} from 'vuex';

export default {
    name: 'SideMenu',
    data() {
        return {
            background: img,
            element: 0,
            cities: [
                'Cancún',
                'Cd. México',
                'Culiacán',
                'Guadalajara',
                'Hermosillo',
                'Juárez',
                'La Paz',
                'Mérida',
                'Mexicali',
                'Monterrey',
                'Nogales',
                'Querétaro',
                'Tijuana',
                'Veracruz',
                'Villahermosa'
            ],
        }
    },
    computed:{
        depName() {
            return this.$store.getters["admin/getDep"];
        },
        elementIndex() {
           let index=0;
          
           let city = this.$store.getters["plants/getHistoryCity"]
           //console.log("sidemenu"+city)
           let cities= [
               'Cancún',
                'Cd. México',
                'Culiacán',
                'Guadalajara',
                'Hermosillo',
                'Juárez',
                'La Paz',
                'Mérida',
                'Mexicali',
                'Monterrey',
                'Nogales',
                'Querétaro',
                'Tijuana',
                'Veracruz',
                'Villahermosa'
            ]

            for(var i=0; i<cities.length; i++){
                 if(city== cities[i]){index = i}
            }
            return index
        },
    },
    methods:{
         ...mapActions('csvplantas', ['setHistoryOptionCsv']),
        ...mapActions('admin', ['changeDeptos']),
        ...mapActions('admin', ['getInfo']),
        activate: function(index){
            //console.log(index)
            this.element = index;
        },
    }
}
</script>

<style scoped>
li{
 font-family: 'FuturaPTDemi';
 color: white;
 padding-bottom: .8rem;
 padding-top: .8rem;
}
li:hover, li.active {
    background-color: #fd832d;
}
ul{
    list-style: none;
    padding: 0px;
    cursor: pointer;
    /* height: calc(100vh - 22rem); */
    height: calc(100vh - 20vh);
    overflow: hidden;
    overflow-y: scroll;
}
</style>